export default function TrustSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" id="trust">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block text-xs font-medium text-accent-600 uppercase tracking-wider mb-2">
            Why Trust Us
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Why Trust Our <span className="text-primary-500">Kakobuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Every product recommendation in our <strong>Kakobuy Spreadsheet</strong> is reviewed based on seller reputation, quality checks, pricing, and buyer feedback.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {[
            { number: "20,000+", label: "Products Listed", icon: "ri-file-list-3-line", bg: "bg-foreground-900" },
            { number: "500+", label: "Trusted Sellers", icon: "ri-user-star-line", bg: "bg-primary-500" },
            { number: "30+", label: "Buying Guides", icon: "ri-book-open-line", bg: "bg-accent-500" },
            { number: "Weekly", label: "Updates", icon: "ri-refresh-line", bg: "bg-secondary-500" },
          ].map((stat) => (
            <div key={stat.label} className="rounded-2xl p-6 md:p-8 text-center transition-all duration-300 hover:-translate-y-1">
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto rounded-2xl ${stat.bg} flex items-center justify-center mb-4`}>
                <i className={`${stat.icon} text-background-50 text-xl md:text-2xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">{stat.number}</div>
              <p className="text-sm text-foreground-600">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {[
            { icon: "ri-checkbox-circle-line", text: "Updated Weekly" },
            { icon: "ri-group-line", text: "Community Sources" },
            { icon: "ri-shield-check-line", text: "Verified Sellers" },
            { icon: "ri-guide-line", text: "Safety Guides" },
            { icon: "ri-search-eye-line", text: "QC Tutorials" },
          ].map((badge) => (
            <div
              key={badge.text}
              className="flex items-center gap-2.5 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-accent-500 text-sm`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 font-medium whitespace-nowrap">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}